<template>
  <div class="withdraw_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/cashlist')"
      >
        <van-icon
          name="bars"
          size="25"
          color="#000"
        />
      </div>
    </div>
    <div class="balance ">
      <p>
        {{ $t('sky.jifen') }}
      </p>
      <p>
        {{ parseInt(data.money) }} 
      </p>
      <p>
        {{ $t('invest.availableBalance') }}   
      </p>
    </div>
    <!-- 		<div class="balance bglight" >
			<dl class="ratio-info ">
			    <dd><span class="text-gray">{{$t('cash.abletimes')}}：</span><em>{{data.cash_maxnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.usdtimes')}}：</span><em>{{data.cashnum}} {{$t('cash.time')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.isable')}}：</span><em>{{$t('cash.yes')}}</em></dd>
			    <dd><span class="text-gray">{{$t('cash.mincash')}}：</span><em>{{data.min_cash}} {{utils_moneyMark()}}</em></dd>
			</dl>
		</div> -->
    <div class="wrap_box wrap1 ">
      <div
        class="choose_bank bgdeep"
        @click="show=true"
      >
        <div>
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div>
          <span>{{ bank_name }}</span>
          <van-icon
            name="arrow"
            color="#999"
          />
        </div>
      </div>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text=""
        :description="this.$t('cash.chooseWallet')"
        close-on-click-action
        @select="onSelect"
      />
      <div class="withdraw_wrap bgdeep">
        <p>{{ $t('cash.amount') }}</p>
        <div
          class="flex_center"
          style="justify-content: left;"
        >
          <span>{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money" 
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('pro2.enteramount')"
            @input="changeAmount"
          >
          <button
            class="allbtn"
            type="button"
            @click="cashall()"
          >
            {{ $t('item.all') }}
          </button>
					
          <!-- <span>{{actualAmount}}</span> -->
        </div>
        <p v-if="chargeTip">
          {{ chargeTip }}
        </p>
      </div>
      
      <!--      <div
        class="basic_btn"
        @click="submit()"
      >
        {{ $t('utils.submit') }}
      </div> -->
      <div
        class="basic_btn"
        @click="write_psd = true;submitType = 1;"
      >
        {{ $t('utils.submit') }}
      </div>
      <p class="canal_tips bglight">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>
    <!--   <div style="margin: 20px;line-height: 20px;text-align: center;margin-top: 50px;">
        	<img class="footimgs" src="../images/ban2/onekey__expedia.svg">
        	<img class="footimgs" src="../images/ban2/onekey__hotels__english.svg">
        	<img class="footimgs" src="../images/ban2/onekey__vrbo.svg">
        </div>
        <div class="footerdesc">
        	<div class="version">
        		Expedia 2025.46.1 (252432001)
        	</div>
        	<div class="copyright">
        	 © Hak Cipta 2012-2025 Expedia Group Semua hak cipta dilindungi undang-undang.
        	</div>
        </div> -->
    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <div
              v-for="i in 9"
              class="key_item"
              @click="onInput(i)"
            >
              <div class="key_inner">
                {{ i }}
              </div>
            </div>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <div
              class="key_item"
              @click="onInput(0)"
            >
              <div class="key_inner">
                0
              </div>
            </div>
            <div
              class="key_item no_bg x"
              @click="onDelete"
            >
              <div class="key_inner">
                x
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <div
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Popup,
		PasswordInput,
		NumberKeyboard,
		Icon,
		ActionSheet
    } from 'vant';
    Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

    export default {
        name: "Cost",
        data() {
            return {
                data: {},
                showKeyboard: true,
                write_psd: false,
                psd_val: '',
				chargeTip:'',
				charge:0,
                form: {
                    money: '',
                    password: '',
                    bank_id: 0,
                },
				eye:1,
				show: false,
				bank_name:this.$t('cash.chooseWallet'),
				actions: [],
				setPwd:false,
				submitType:1,
				type:1,
				rate:1,
				mark:"$",
				actualAmount:''
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.start();
        },
        methods: {
			cashall(){
				this.form.money = this.data.money;
				this.changeAmount();
			},
			onSelect(item){
				this.chargeTip = "";
				this.actualAmount = "";
				this.form.money = "";
				this.show = false;
				this.bank_name = item.name;
				this.form.bank_id = item.value;
				this.charge = item.charge;
				this.type = item.type;
				this.rate = item.rate;
				this.mark = item.mark;
				if(item.charge>0){
					this.chargeTip = this.$t('cash.charge')+item.charge+"%";
				}else{
					this.chargeTip = "";
				}
				if(item.value==0){
					this.$router.push('/addcountUsdt')
				}
			},
			changeAmount(){
				this.chargeTip = "";
				var rateTip = "";
				var num = 2;
					// if(this.type==1){
					// 	if(this.rate>10000){
					// 		num = 8;
					// 	}else if(this.rate>1000){
					// 		num = 6;
					// 	}else if(this.rate>10){
					// 		num = 4;
					// 	}
					// 	this.actualAmount = "≈"+(this.form.money/this.rate).toFixed(num)+this.mark;
					// 	rateTip = "≈"+(this.form.money*this.charge/100/this.rate).toFixed(num)+this.mark+"";
					// }else{
						this.actualAmount = "≈"+this.mark+(this.form.money/this.rate).toFixed(num);
						rateTip = "≈ "+(this.form.money*this.charge/100).toFixed(num)+" "+this.mark+"";
					// }
				if(this.charge>0){
					this.chargeTip = this.$t('cash.charge')+""+rateTip;
					// this.chargeTip = this.$t('cash.charge')+":$"+(this.form.money*this.charge/100).toFixed(num)+rateTip;
				}
			},
            onInput(key) {
                this.psd_val = (this.psd_val + key).slice(0, 6);
                if (this.psd_val.length == 6) {
					this.write_psd = false;
					this.form.password = this.psd_val;
					if(this.submitType==1){
						this.submit();
					}else{
						this.setIniPwdSubmit();
					}
					
                }
            },
            onDelete() {
                this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
            },
            subAll() {
                this.form.money = this.data.money;
            },
            start() {
                Fetch('/user/my_bank').then((r) => {
                    this.data = r.data;
					this.data.money = this.data.money.toFixed(0);
					this.setPwd = r.data.intPwd;
                    var bankvalue = [];
                    r.data.bank.forEach(item => {
						var length = item.account.length;
						var account = item.account+"";
						var itemAccount = account.substr(length-10,length)
                        bankvalue.push({
                            name: item.bank+"(****"+itemAccount+")",
                            value: item.id,
							charge:item.charge,
							rate:item.rate,
							type:item.type,
							mark:item.mark
                        })
                    })
					bankvalue.push({
					    name: this.$t('cash.addWallet'),
					    value: 0,
						color:"#FF0000",
					})
					this.actions = bankvalue;
					if(bankvalue.length>1){
						this.onSelect(bankvalue[0])
					}
                });
            },
            submit() {
				this.psd_val="";
                if (!this.form.money) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if(this.form.money < 0){
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
				if(parseInt(this.form.money) > parseInt(this.data.money)){
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                if (this.form.bank_id == 0 || this.form.bank_id == -1) {
                    this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                    return false;
                }
				if (!this.form.password || this.form.password.length!=6) {
                    this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                    return false;
                }
                Fetch('/user/cost_apply', {
                    money: this.form.money,
                    bank_id: this.form.bank_id,
                    passwd: this.form.password
                }).then(() => {
                    this.$toast({
                        background: '#07c160',
                        message: this.$t('cash.success')
                    });
                    this.$router.replace('/user')
                });
            },
			setIniPwdSubmit(){
				this.psd_val="";
				Fetch('/user/setIniPwd', {
				    password: this.form.password
				}).then(() => {
					this.setPwd = false;
				});
			},
			setIniPwd(){
				this.submitType = 2;
				this.write_psd = true;
			}
        }
    };
</script>

<style lang="less" scoped>
	
	/deep/ .van-action-sheet__item {
	    text-align: left;
	}
	/deep/ .van-popup--bottom{
		border-radius:0;
		// padding-bottom: 15px;
	}
	.balance{
		border-radius: 6px;
		padding: 20px 0px;
		text-align: center;
		margin: 10px;
		border: 1px solid #CCC;
		p:nth-child(1){
			color: #000;
			font-size: 14px;
			margin-bottom: 15px;
		}
		p:nth-child(2){
			color: #000;
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 15px;
		}
		p:nth-child(3){
			color: #999;
			font-size: 14px;
			font-weight: bold;
		}
	}

    .wrap1 {
        margin: 10px;
		box-shadow: none;
		background: none;
		.choose_bank{
			width: 100%;
			background: #fff;
			border-radius: 5px;
			padding: 15px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 10px;
			border: 1px solid #CCC;
			div:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #282828;
			}
			div:nth-child(2){
				text-align: right;
				font-size: 12px;
				font-weight: bold;
				color: #282828;
			}
		}
		.withdraw_wrap{
			width: 100%;
			background: #fff;
			border-radius: 6px;
			padding: 16px;
			margin-top: 10px;
			border: 1px solid #CCC;
			input{
				height: 18px;
				width: 100%;
				line-height: 18px;
				font-size: 14px;
			}
			div{
				span:nth-child(1){
					width: 65px;
					font-size: 18px;
					margin-right: 10px;
					font-weight: bold;
				}
				span:nth-child(2){
					font-size: 14px;
					margin-left: 20px;
					font-weight: bold;
					width: 15%;
					color: #282828;
					text-align: right;
				}
			}
			p:nth-child(1){
				font-size: 14px;
				font-weight: bold;
				color: #282828;
				margin-bottom: 20px;
			}
			p:nth-child(3){
				color: #282828;
				margin-top: 20px;
			}
		
		}
    }
	.canal_tips {
		border-top: 1px solid #ECECEC;
		display: block;
		padding: 16px;
		border-radius: 5px;
		line-height: 24px;
		font-size: 12px;
		margin-top: 10px;
		background-color: #0063d2;
		color: #ffffff;
    }
    .basic_btn {
        margin: 53px auto 0 auto;
		border-radius: 5px;
    }

    /deep/ .van-password-input {
        margin: 50px 28px 0 28px;
    }

    /deep/ .van-hairline--left::after {
        border: 1px solid #ECECEC;
    }

    .van-password-input .van-password-input__security::after {
        border-radius: 0;
    }

    .keybord_box {
        height: 250px;
        background-color: #F0F0F0;
        margin-top: 35px;
        padding: 24px 12px 0 12px;

        .keybord {
            width: 361px;
            margin: 24px auto 0 atuo;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            text-align: center;

            .key_item {
                width: 115px;
                height: 44px;
                line-height: 44px;
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 6px;
                background: rgba(255, 255, 255, 1);
                border-radius: 3px;

                &.no_bg {
                    background: none;
                }

                &.x {
                    color: #757880;
                    font-weight: bold;
                }
            }
        }
    }
	
	.ratio-info{
	    display: grid;
	    grid-template-columns: repeat(2,1fr);
	    row-gap: 14px;
	    padding: 0px 20px;
	    line-height: 1;
		dd{
		    margin: 0;
		}
		em {
		    font-style: normal;
		    font-size: 14px;
		}
	}
	.text-gray {
	    color: #ababab;
	}
	.basic_wrap{
		position: relative;
		height: 100vh;
	}
	/deep/ .van-popup--bottom{
		position: absolute;
	}
	.allbtn{
		height: 25px;
		line-height: 20px;
		padding: 2px 8px;
		border-radius: 5px;
		margin-left: 10px;
		font-size: 10px;
		background-color: #0063d2;
		color: #fff;
		width: 80px;
	}
</style>
